module.exports = __webpack_public_path__ + "img/HA1511-163.598f3db2.jpg";